import React, {forwardRef} from "react"
import FieldProto from "../proto/field-proto";
import {FieldAccess} from "../const";

export type FieldFormElementProps = {
    field           : FieldProto
    form            : any
    model?          : any       // some form elements need to know which model this is for...
    className?      : string
    disabled?       : boolean
    options?        : any           // anything else nned type !!!!
    configOptions?  : any       // anything else (better name instead of options?)
    rows?           : number        // used in text area

    onEnter?        : func
};

const debug = false
// const debug = "FieldFormElement"

// zachem tut forwardRef ???? navernoe nuzen...

const FieldFormElement = forwardRef(function(props:FieldFormElementProps, ref):any {

    let disabled    = false

    if (!_.isNil(props.disabled)) { // check if disabled property is overridden
        disabled = props.disabled || false
    } else if (props.field.isDisabled) {
        disabled = true
    } else {
        switch (props.field.access(props.model)) {
            case false      :
                return false
            case FieldAccess.READ     :
                disabled = true   // po idee eto auto disable sdelaet dlya read only fields
                break
            case FieldAccess.WRITE    :
                break
        }
    }



    debug && console.log(debug, 'render', disabled, props)

    return <props.field.renderComponents.formElement ref            = {ref}
                                                     field          = {props.field}
                                                     form           = {props.form}
                                                     model          = {props.model}
                                                     className      = {props.className}
                                                     disabled       = {disabled}
                                                     options        = {props.options || props.configOptions}
                                                     configOptions  = {props.configOptions || props.options}
                                                     rows           = {props.rows}
                                                     onEnter        = {props.onEnter}/>

})

export default FieldFormElement
